/* eslint-disable react/jsx-indent */
/* eslint-disable no-restricted-syntax */
import React, { useCallback, useEffect, useState } from 'react';

import { Card, Spin } from 'antd';
import { FaFilter, FaFileExcel } from 'react-icons/fa';

import { v4 } from 'uuid';
import { useApi } from '../../hooks/api';

import './styles.scss';
import Table from '../../components/Table';
import { IActionHeaderConfig, ITableColumn } from '../../interfaces/table';
import IClientsList from '../../interfaces/clients';
import ClientsConsumptionReportFilters from '../../components/ClientsConsumptionReportFilters';
import { notificationDCS } from '../../utils/notificationDcs';


interface IClientsConsumptionTable {
  date: string;
  client_id: string;
  qty_send_messages_whatsapp: number;
  qty_delivered_messages_whatsapp: number;
  qty_receveid_messages_whatsapp: number;
  qty_hsm_auth: number;
  qty_hsm_svc: number;
  qty_hsm_mkt: number;
  qty_hsm_utl: number;
  qty_send_sms: number;
  qty_hsm_send: number;
}

const ClientsConsumptionReport: React.FC = () => {
  const { api } = useApi();
  const [clients, setClients] = useState<IClientsList[]>([]);
  const [clientsConsumptionTable, setClientsConsumptionTable] = useState<
    IClientsConsumptionTable[]
  >([]);

  const [loadingClientsConsumption, setLoadingClientsConsumption] =
    useState(false);

  const [showFilters, setShowFilters] = useState(false);

  const [filters, setFilters] = useState({
    client_id: '',
    start_date: '',
    end_date: '',
  });

  const loadClients = useCallback(async () => {
    const response = await api.get('/clients');
    setClients(response.data);
  }, [api]);


  const loadClientsConsumption = useCallback(
    async (
      client_id = filters.client_id,
      start_date = filters.start_date,
      end_date = filters.end_date,
    ) => {
      setLoadingClientsConsumption(true);

      const response = await api.get(`/reports/consumption`, {
        params: {
          client_id,
          start_date,
          end_date,
        },
      });

      const { data } = response;
      setClientsConsumptionTable(data);
      setLoadingClientsConsumption(false);
    },
    [
      api,
      filters.start_date,
      filters.end_date,
      filters.client_id,
    ],
  );

  const handleExportXLSX = useCallback(async () => {
    try {
      const response = await api.post(`/reports/consumption/export`, filters);
      if (response.status === 200) {
        window.open(response.data.report_url, '_blank');
      } else {
        notificationDCS({
          type: 'warning',
          message: 'Atenção',
          description: 'Não há registros referente aos filtros informados!',
        });
      }
    } catch (error) {
      notificationDCS({
        type: 'error',
        message: 'Atenção',
        description: 'Falha ao consumir api!',
      });
    }
    
  }, [clientsConsumptionTable]);


  const tableColumns: ITableColumn[] = [
    {
      id: v4(),
      name: 'Data',
      dataIndex: 'date',
      responsive: true,
    },
    {
      id: v4(),
      name: 'SMS',
      dataIndex: 'qty_send_sms',
      responsive: false,
      
    },
    {
      id: v4(),
      name: 'HSM Enviados',
      dataIndex: 'qty_hsm_send',
      responsive: false,
    },
    {
      id: v4(),
      name: 'HSM Marketing',
      dataIndex: 'qty_hsm_mkt',
      responsive: false,
    },
    {
      id: v4(),
      name: 'HSM Service',
      dataIndex: 'qty_hsm_svc',
      responsive: false,
    },
    {
      id: v4(),
      name: 'HSM Utility',
      dataIndex: 'qty_hsm_utl',
      responsive: false,
    },
    {
      id: v4(),
      name: 'HSM Auth',
      dataIndex: 'qty_hsm_auth',
      responsive: false,
    },
    {
      id: v4(),
      name: 'WPP Enviadas',
      dataIndex: 'qty_send_messages_whatsapp',
      responsive: false,
    },
    {
      id: v4(),
      name: 'WPP Entregues',
      dataIndex: 'qty_delivered_messages_whatsapp',
      responsive: false,
    },
    {
      id: v4(),
      name: 'WPP Recebidas',
      dataIndex: 'qty_receveid_messages_whatsapp',
      responsive: false,
    },
  ];

  const onSearch = useCallback(
    (
      client_id: string,
      start_date: string,
      end_date: string,
    ) => {
      const filtersData = {
        client_id: client_id ?? filters.client_id,
        start_date: start_date ?? filters.start_date, 
        end_date: end_date ?? filters.end_date,
      };

      setFilters(filtersData);

      loadClientsConsumption(
        filtersData.client_id,
        filtersData.start_date,
        filtersData.end_date,
      );
      setShowFilters(false);
    },
    [
      filters.client_id,
      filters.start_date,
      filters.end_date,
      loadClientsConsumption,
    ],
  );

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  const headerActions: IActionHeaderConfig[] = [
    ...(clientsConsumptionTable.length > 0
      ? [
        {
          titleAction: 'Exportar XLSX',
          icon: <FaFileExcel />,
          action: handleExportXLSX,
        },
      ]
      : []),
    {
      titleAction: 'Filtros',
      icon: <FaFilter />,
      action: () => {
        setShowFilters(true);
      },
    },
  ];

  return (
    <Card className="card-reports">
      <Spin spinning={loadingClientsConsumption} size="large">
        <Table
          title="Gestão de consumo"
          data={clientsConsumptionTable}
          keyIndex="id"
          tableColumns={tableColumns}
          loading={loadingClientsConsumption}
          actionsConfig={headerActions}
          action={false}
          isPaginated={false}
        />
        <ClientsConsumptionReportFilters
          closeFilters={() => setShowFilters(false)}
          showFilters={showFilters}
          search={onSearch}
          clients={clients}
        />
      </Spin>
    </Card>
  );
};

export default ClientsConsumptionReport;
